// ====================================================================================
// collapse.module
// ====================================================================================
import { Collapse } from "bootstrap";

export const init = () => {
  let attempts = 0;

  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      let panels = document.querySelectorAll(".collapse");

      panels.forEach((panel) => {
        new Collapse(panel, { toggle: false });

        panel.addEventListener("show.bs.collapse", function (e) {
          // this.classList.add("show");
          let parent = this.closest(".panel");
          if (parent) parent.classList.add("active");
          let panelBtn = parent.querySelector(".panel__btn");
          if (panelBtn) panelBtn.classList.add("panel__btn--open");
        });

        panel.addEventListener("hide.bs.collapse", function (e) {
          // this.classList.remove("show");
          let parent = this.closest(".panel");
          if (parent) parent.classList.remove("active");
          let panelBtn = parent.querySelector(".panel__btn");
          if (panelBtn) panelBtn.classList.remove("panel__btn--open");
        });
      });
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
